import type { DependencyList } from 'react';
import { useEffect } from 'react';

// NOTE: `useEffect` does not allow async functions.
export default function useAsyncEffect(
  asyncFunc: () => Promise<void>,
  dependencies: DependencyList
): void {
  useEffect(() => {
    let cancelled = false;
    const retryDelayMs = 500;

    (async function () {
      let attempt = 0;
      const maxRetries = 5;
      while (!cancelled && attempt < maxRetries) {
        try {
          await asyncFunc();
          break;
        } catch {
          attempt += 1;
          if (attempt >= maxRetries || cancelled) {
            break;
          }
          await new Promise(res => setTimeout(res, retryDelayMs));
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, dependencies);
}
